import { useAuth } from "@clerk/clerk-react";
import { Box, Group, Space, Stack, Text, Title } from "@mantine/core";
import { ScriptCreatedBy } from "@/components/script/script-created-by";
import { useHasScriptFeatureAccess } from "@/hooks/use-has-script-feature-access";
import { ScriptUpgradeMembershipTierBanner } from "@/components/script/script-upgrade-membership-tier-banner";
import { ScriptBookmarkButton } from "@/components/script/script-bookmark-button";
import { ScriptRating } from "@/components/script/script-rating";
import { ScriptTags } from "@/components/script/script-tags";
import { ScriptIntendedSex } from "@/components/script/script-intended-sex";
import { scriptQueryOptions } from "@/api/fapinstructor/script/get-script";
import { createFileRoute } from "@tanstack/react-router";
import { ScriptForm } from "./-components/script-form";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/script/$scriptId/",
)({
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      scriptQueryOptions({ scriptId: opts.params.scriptId }),
    ),
  component: ScriptDetailsRouteComponent,
});

function ScriptDetailsRouteComponent() {
  const script = Route.useLoaderData();
  const { userId } = useAuth();
  const hasScriptFeatureAccess = useHasScriptFeatureAccess();
  const isAuthor = userId === script.createdBy.id;

  if (!isAuthor || !hasScriptFeatureAccess) {
    return (
      <>
        {isAuthor && !hasScriptFeatureAccess ? (
          <ScriptUpgradeMembershipTierBanner />
        ) : null}
        <Box my="lg">
          <Stack gap="xs">
            <Box>
              <Group gap="0.5ch">
                <ScriptIntendedSex script={script} />
                <Title size="h2">{script.title}</Title>
                <ScriptBookmarkButton script={script} />
              </Group>
              <ScriptCreatedBy script={script} />
              {script.tags.length > 0 ? <Space h="xs" /> : null}
              <ScriptTags script={script} variant="light" />
              <Text my="md">{script.description}</Text>
              <ScriptRating script={script} />
            </Box>
          </Stack>
        </Box>
      </>
    );
  }

  return <ScriptForm script={script} />;
}
